import { Backdrop, Box, Typography } from "@mui/material";
import pageLoading from "../../_assets/images/sea-pro-loading.gif";
import LoaderBox from "./LoaderBox";

interface IProps {
  loading: boolean;
}

const AppLoader = ({ loading }: IProps) => {
  return loading ? (
      <>
        <Backdrop
          sx={(theme) => ({ 
            color: '#000', 
            zIndex: 5000,
            backgroundColor: 'transparent',
          })}
          
          open={loading}
        >
          <LoaderBox showTitle />
        </Backdrop>

        {/* This backdrop covers up side panels during load */}
        <Backdrop
          sx={(theme) => ({ 
            zIndex: 5001,
            backgroundColor: 'rgba(255, 255, 255, .3)',
          })}
          
          open={loading}
        >

        </Backdrop>
        
      </>
        
        
  ) : null;
};
export default AppLoader;
